import React from "react";
import { View, Text } from "react-native";

import { checkIcon } from "@/utils/transactions/ExchangeCurrencies";

interface Props {
  symbol: string;
  balance: number;
}
export default function CardToken(props: Props) {
  return (
    <View className="flex-row items-center gap-2 bg-gray border border-lightgray rounded-lg p-2">
      {checkIcon(props.symbol, 28)}
      <Text className="text-lg">{props.balance}</Text>
      <Text className="text-lg font-light">{props.symbol}</Text>
    </View>
  );
}
